
    <div class="pt-0 pb-5 container-fluid questions-list">
            <div class="row gx-0 fw-bold pt-5">
                <div class="col-1 text-center">{{'polls_settings.status' | translate}}</div>
                <div class="col-4 text-center">{{'polls_settings.label' | translate}}</div>
                <div class="col-2 text-center">{{'polls_settings.author' | translate}} - {{'polls_settings.properties' | translate}}</div>
                <div class="col-2 text-center">{{'polls_settings.scope' | translate}}</div>
                <div class="col-3 text-center">{{'polls_settings.recurrence' | translate}}</div>
            </div>
            @if(!polls) {
                <div class="col py-5">{{ 'polls_settings.loading' | translate}}</div>
            }
            @if(polls?.questions.length === 0){
                <em class="text-secondary">{{ 'polls_settings.bank.search_empty' | translate}}</em>
            }@else{
                @for(poll of polls?.questions; let i = $index; track poll.id){
                    <div class="mt-2 mb-3 p-3 border rounded question-list-item" data-cy="userQuestionItem" id="{{poll.id}}">
                         <!-- top : common infos  -->
                        <div class="row">
                            <div class="col-1 text-center center-column">
                                @if(poll.status === 'ScheduledQuestionStatus'){
                                    <span class="badge fw-semibold text-dark bg-warning-subtle border border-warning-subtle"><i class="fa-solid fa-circle-small text-warning pe-1"></i>{{'polls_settings.status.scheduled' | translate}}</span>
                                }
                                @if(poll.status === 'FinishedQuestionStatus'){
                                    <span class="badge fw-semibold text-bg-light bg-light"><i class="fa-solid fa-circle-small pe-1"></i>{{'polls_settings.status.ended' | translate}}</span>
                                }
                                @if(poll.status === 'LiveQuestionStatus'){
                                    <span class="badge fw-semibold text-success bg-success-subtle border border-success-subtle rounded-2"><i class="fa-solid fa-circle-small pe-1"></i>{{'polls_settings.status.live' | translate}}</span>
                                }
                            </div>
                            <div class="col-4 ps-1 center-column">
                                <span>"<span class="fst-italic" [innerHTML]="poll.label | highlight_search: searchTerm"></span>"</span>
                            </div>
                            <div class="col-2 text-center center-column">
                                <div>
                                    <small class="fw-bold pe-1">{{poll.author.fullname}}</small>
                                    @if(poll.displayAuthor){
                                        <span>
                                            <i class="fa fa-mask" matTooltip="{{'polls_settings.author_anonymous' | translate}}"></i>
                                        </span>
                                    } @else {
                                        <span class="fa-stack ps-1" matTooltip="{{'polls_settings.author_not_anonymous' | translate}}">
                                            <i class="fa fa-mask fa-stack-1x"></i>
                                            <i class="far fa-slash fa-stack-1x"></i>
                                        </span>
                                    }
                                    @if(poll.allowComments){
                                        <span class="ps-1">
                                            <i class="far fa-comment" matTooltip="{{'poll_creation.customize_allow_comments_preview' | translate}}"></i>
                                        </span>
                                    } @else {
                                        <span class="fa-stack ps-1" matTooltip="{{'poll_creation.customize_not_allow_comments_preview' | translate}}">
                                            <i class="far fa-comment fa-stack-1x"></i>
                                            <i class="far fa-slash fa-stack-1x"></i>
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="col-2 text-center center-column">
                                <team-chip-list [teams]="poll.teams"></team-chip-list>
                            </div>
                            
                            @if(poll.recurrence.frequency !== 'once'){
                                <div class="col-3 text-center pt-1 center-column">
                                    <div class="m-1">
                                        <i [ngClass]="{'d-none': !poll.recurrence.enabled || poll.recurrence.frequency === 'once'}"
                                        class="fa-regular fa-arrows-repeat fs-6 pe-2"></i>
                                        <i [ngClass]="{'d-none': poll.recurrence.enabled || poll.recurrence.frequency === 'once'}"
                                            class="fa-regular fa-play-pause fs-6 pe-2"></i>
                                        <span class="fst-italic">
                                            @switch (poll.recurrence.frequency){
                                                @case ('weekly'){
                                                    {{'polls_settings.recurrence_preview.weekly' | translate: {'value': getFrequencyStartDay(poll.occurrences[0].startDate, 'weekly')} }}
                                                }
                                                @case ('monthly'){ 
                                                    {{'polls_settings.recurrence_preview.monthly' | translate: {'value': getFrequencyStartDay(poll.occurrences[0].startDate, 'monthly')} }}
                                                }
                                            }
                                        </span>
                                        <span class="ps-2">
                                            <tm-slide-toggle id="togglePollRecurrence"
                                                             [ngModel]="poll.recurrence.enabled" 
                                                             (ngModelChange)="toggle_recurrence(poll)"></tm-slide-toggle>
                                        </span>
                                    </div>
                                    @if(poll.showTrends){
                                        <button class="btn btn-outline-primary btn-sm py-1 border-0" (click)="showTrendsInPollResultDialog(poll)">
                                            <i class="far fa-chart-line pe-1"></i> {{ 'polls_settings.show_trends' | translate}}
                                        </button>
                                    }
                                </div>
                            }@else{
                                <div class="col-3 text-center center-column">
                                    <div>
                                        <!-- #docregion mat-menu-trigger-for -->
                                        <button matButton [matMenuTriggerFor]="menu"
                                        class="btn btn-outline-primary btn-sm border-0 m-1">
                                            <i class="fa-regular fa-arrows-repeat pe-1"></i><i class="fa-regular fa-play-pause pe-1"></i>{{'polls_settings.recurrence.make_recurrent' | translate}}
                                        </button>
                                        <!-- #enddocregion mat-menu-trigger-for -->
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item (click)="makePollRecurrent(poll, 'weekly')">{{'polls_settings.recurrence.make_recurrent.weekly' | translate}}</button>
                                            <button mat-menu-item (click)="makePollRecurrent(poll, 'monthly')">{{'polls_settings.recurrence.make_recurrent.monthly' | translate}}</button>
                                        </mat-menu>
                                    </div> 
                                    @if(poll.showTrends){
                                        <button class="btn btn-outline-primary btn-sm py-1 border-0" (click)="showTrendsInPollResultDialog(poll)">
                                            <i class="far fa-chart-line pe-1"></i> {{ 'polls_settings.show_trends' | translate}}
                                        </button>
                                    }
                                </div>
                            }
                         </div>   
                       
                         <!-- bottom : occurence details  -->
                        <div class="border-top mt-3 pt-3 d-flex">
                            <user-poll-occurrence-list [poll]="poll"
                                                       [teams]="teams"
                                                        (onDeletePollOccurrence)="remove($event)"></user-poll-occurrence-list>
                            
                        </div>
                    </div>
                }
            }   
    </div>